import { render, staticRenderFns } from "./allocationStorehouseHistoryAuditOrdersList.vue?vue&type=template&id=303bb81f&scoped=true"
import script from "./allocationStorehouseHistoryAuditOrdersList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseHistoryAuditOrdersList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseHistoryAuditOrdersList.vue?vue&type=style&index=0&id=303bb81f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303bb81f",
  null
  
)

export default component.exports